__turbopack_context__.v({
  "headerLogo": "HeaderLogo-module-scss-module__ciLInW__headerLogo",
  "link": "HeaderLogo-module-scss-module__ciLInW__link",
  "link__grey": "HeaderLogo-module-scss-module__ciLInW__link__grey",
  "svgburger": "HeaderLogo-module-scss-module__ciLInW__svgburger",
  "svglogo": "HeaderLogo-module-scss-module__ciLInW__svglogo",
});
